<template>
    <zk-admin-table title="精准关怀体检申请" :loading="loading" :table="table" @change="handleTableChange">
        <template v-slot:buttons>
            <el-row style="float: right">
                <el-button type="primary" size="small" @click="handleAdd" icon="el-icon-plus">申请体检</el-button>
                <el-button type="default" size="small" @click="getData" icon="el-icon-refresh">刷新</el-button>
            </el-row>
        </template>

        <template v-slot:search>
            <zk-search-form-inline :form="search" @search="getData">
                <el-form-item label="姓名">
                    <el-input v-model.trim="search.name" clearable style="width:120px"></el-input>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input v-model.trim="search.id_card" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="search.status" placeholder="全部" clearable style="width:120px">
                        <el-option label="已申请" value="0"></el-option>
                        <el-option label="已审核" value="1"></el-option>
                        <el-option label="审核不通过" value="-1"></el-option>
                        <el-option label="已收费" value="2"></el-option>
                    </el-select>
                </el-form-item>
            </zk-search-form-inline>
        </template>

        <el-table-column type="index" width="50" align="center" />
        <el-table-column prop="secondary_unit" label="二级单位" width="150" align="center" />
        <el-table-column prop="name" label="姓名" width="100" align="center" />
        <el-table-column prop="id_card" label="身份证号" width="170" align="center" />
        <el-table-column prop="status" label="状态" width="100" align="center">
            <template slot-scope="scope">
                <el-tag v-if="scope.row.status == 0" type="primary" size="mini">已申请</el-tag>
                <el-tag v-else-if="scope.row.status == 1" type="success" size="mini">已审核</el-tag>
                <el-tag v-else-if="scope.row.status == -1" type="danger" size="mini">审核不通过</el-tag>
                <el-tag v-else-if="scope.row.status == 2" type="warning" size="mini">已收费</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="items" label="检查项目" align="center" width="200">
            <template slot-scope="scope">
                <el-tag v-for="(item, index) in scope.row.items" :key="index" size="mini" style="margin-right: 5px;">{{
                    item }}</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="total_cost" label="费用合计" width="100" align="center">
            <template slot-scope="scope">
                {{ scope.row.total_cost }} 元
            </template>
        </el-table-column>
        <el-table-column prop="created" label="申请时间" width="160" align="center" />
        <el-table-column prop="created_by" label="申请人" width="100" align="center" />
        <el-table-column prop="hospital" label="体检机构" width="190" align="center" />
        <el-table-column prop="expert_name" label="研判专家姓名" width="120" align="center" />
        <el-table-column prop="audit_at" label="审核时间" width="160" align="center" />
        <el-table-column prop="audit_by" label="审核人" width="100" align="center" />
        <el-table-column prop="audit_reason" label="审核意见" width="200" align="center" />

        <el-table-column align="center" width="180" label="操作" fixed="right">
            <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="handleUpdate(scope.row)"
                    v-if="scope.row.status === 0 || scope.row.status === -1">编辑</el-button>
                <el-button size="mini" type="danger" @click="handleDelete(scope.row)"
                    v-if="scope.row.status === 0 || scope.row.status === -1">删除</el-button>
            </template>
        </el-table-column>

        <template v-slot:dialog>
            <el-dialog :title="form.id ? '编辑申请单' : '新建申请单'" :visible.sync="dialogVisible" :close-on-click-modal="false"
                fullscreen custom-class="apply-fullscreen-dialog">
                <div class="apply-page">
                    <div class="apply-page-head">
                        <div>
                            <div class="apply-page-title">精准关怀体检申请单</div>
                            <div class="apply-page-subtitle">请按顺序填写基本信息、准入标准和项目选择</div>
                        </div>
                        <div class="apply-summary">
                            <div class="summary-item">
                                <span>已选项目</span>
                                <strong>{{ selectedProjectIds.length }}</strong>
                            </div>
                            <div class="summary-item">
                                <span>准入勾选</span>
                                <strong>{{ form.admission_criteria.length }}</strong>
                            </div>
                            <div class="summary-item total">
                                <span>费用合计</span>
                                <strong>{{ currentTotalCost }} 元</strong>
                            </div>
                        </div>
                    </div>

                    <div class="apply-page-content">
                        <el-form ref="form" :model="form" label-width="110px" :rules="rules">
                            <section class="sheet-card">
                                <div class="sheet-card-title">一、基本信息</div>
                                <el-row :gutter="20">
                                    <el-col :span="24">
                                        <el-form-item label="员工选择" prop="staff_id">
                                            <select-staff v-model="form.staff_id" @input="syncStaffInfo" />
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </section>

                            <section class="sheet-card">
                                <div class="sheet-card-title">二、精准关怀项目准入标准</div>
                                <div class="sheet-card-desc">项目选择与准入标准已合并：勾选项目或其条件即可计入该项目费用</div>
                                <el-form-item prop="admission_criteria" label-width="0" class="sheet-form-item">
                                    <el-checkbox-group v-model="form.admission_criteria" class="criteria-groups"
                                        @change="handleAdmissionCriteriaChange">
                                        <div class="criteria-group" v-for="group in admissionStandardSections"
                                            :key="group.id">
                                            <div class="criteria-project">
                                                <el-checkbox :label="group.id" class="criteria-project-checkbox">
                                                    <span class="criteria-project-title">{{ group.project }}</span>
                                                </el-checkbox>
                                                <span class="criteria-project-price">{{ group.price }} 元</span>
                                            </div>
                                            <div class="criteria-label" v-if="group.required && group.required.length">
                                                必选项</div>
                                            <div class="criteria-options"
                                                v-if="group.required && group.required.length">
                                                <el-checkbox v-for="requiredItem in group.required"
                                                    :key="requiredItem.id" :label="requiredItem.id">
                                                    {{ requiredItem.label }}
                                                </el-checkbox>
                                            </div>
                                            <div class="criteria-label" v-if="group.optional && group.optional.length">
                                                {{ group.optionalRule || '可选项' }}
                                            </div>
                                            <div class="criteria-options criteria-options-grid"
                                                v-if="group.optional && group.optional.length">
                                                <el-checkbox v-for="optionalItem in group.optional"
                                                    :key="optionalItem.id" :label="optionalItem.id">
                                                    {{ optionalItem.label }}
                                                </el-checkbox>
                                            </div>
                                        </div>
                                    </el-checkbox-group>
                                </el-form-item>
                            </section>

                            <section class="sheet-card">
                                <div class="sheet-card-title">三、医院信息</div>
                                <el-row :gutter="20">
                                    <el-col :span="24">
                                        <el-form-item label="研判专家姓名" prop="expert_name">
                                            <el-input v-model.trim="form.expert_name"
                                                placeholder="请输入研判专家姓名"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </section>
                        </el-form>
                    </div>

                    <div class="apply-page-footer">
                        <div class="footer-total">费用合计：<strong>{{ currentTotalCost }} 元</strong></div>
                        <div class="footer-actions">
                            <el-button @click="dialogVisible = false">取 消</el-button>
                            <el-button type="primary" @click="handleSubmit" :loading="loading">提交申请</el-button>
                        </div>
                    </div>
                </div>
            </el-dialog>
        </template>
    </zk-admin-table>
</template>

<script>
import SelectStaff from '../../components/form/selectStaff.vue';

const ADMISSION_STANDARD_SECTIONS = [
    {
        id: 'cta_combo',
        project: '头颈、冠脉二合一CTA',
        price: 1200,
        required: [
            { id: 'cta_combo_req_stenosis', label: '颈动脉狭窄 >= 50%' }
        ]
    },
    {
        id: 'coronary_cta',
        project: '冠脉CTA',
        price: 1200,
        required: [
            { id: 'coronary_cta_req_symptom_plaque', label: '有临床症状 + 颈动脉斑块' }
        ],
        optionalRule: '可选项（必选项 + 下列任选三项）',
        optional: [
            { id: 'coronary_cta_opt_septal_thickening', label: '室间隔厚' },
            { id: 'coronary_cta_opt_left_atrial_enlarge', label: '左室增大' },
            { id: 'coronary_cta_opt_hyperglycemia', label: '血糖升高' },
            { id: 'coronary_cta_opt_bmi_28', label: 'BMI >= 28' },
            { id: 'coronary_cta_opt_hypertension', label: '血压偏高' },
            { id: 'coronary_cta_opt_dyslipidemia', label: '血脂异常' },
            { id: 'coronary_cta_opt_male_age_45', label: '男性年龄 >= 45' }
        ]
    },
    {
        id: 'holter_24h',
        project: '24小时动态心电',
        price: 300,
        required: [
            { id: 'holter_24h_req_arrhythmia', label: '出现明确的室性早搏或心律失常' }
        ]
    },
    {
        id: 'mra_brain',
        project: '颅脑核磁MRA',
        price: 1000,
        required: [
            { id: 'mra_brain_req_plaque', label: '有颈动脉斑块' }
        ],
        optionalRule: '可选项（必选项 + 下列任选三项）',
        optional: [
            { id: 'mra_brain_opt_septal_thickening', label: '室间隔厚' },
            { id: 'mra_brain_opt_left_atrial_enlarge', label: '左室增大' },
            { id: 'mra_brain_opt_hyperglycemia', label: '血糖升高' },
            { id: 'mra_brain_opt_bmi_24', label: 'BMI >= 24' },
            { id: 'mra_brain_opt_hypertension', label: '血压偏高' },
            { id: 'mra_brain_opt_dyslipidemia', label: '血脂异常' },
            { id: 'mra_brain_opt_male_age_45', label: '男性年龄 >= 45' },
            { id: 'mra_brain_opt_severe_athero', label: '重度动脉硬化' }
        ]
    },
    {
        id: 'lung_nodule_analysis',
        project: '肺小结节肿瘤分析',
        price: 400,
        optionalRule: '可选项（二选一）',
        optional: [
            { id: 'lung_nodule_opt_solid', label: '有实性结节或部分实性结节的实性成分，平均直径 >= 6mm 且 < 15mm' },
            { id: 'lung_nodule_opt_non_solid', label: '有非实性结节平均直径 >= 8mm 且 < 15mm 者' }
        ]
    },
    {
        id: 'breast_mammography',
        project: '乳腺钼靶',
        price: 300,
        required: [
            { id: 'breast_mammography_req_birads4', label: '乳腺B超检查结果显示为 BI-RADS 4类及以上' }
        ]
    }
];

export default {
    name: 'keycare_register',
    path: '/main/keycare/register',
    components: {
        SelectStaff
    },
    meta: {
        title: '精准关怀体检申请',
    },
    data() {
        return {
            loading: false,
            dialogVisible: false,
            search: {
                name: '',
                id_card: '',
                status: ''
            },
            table: {
                columns: [],
                data: [],
                total: 0,
                page: 1,
                pageSize: 20
            },
            form: {
                staff_id: null,
                name: '',
                id_card: '',
                secondary_unit: '',
                items: [],
                expert_name: '',
                admission_criteria: [],
                total_cost: 0
            },
            admissionStandardSections: ADMISSION_STANDARD_SECTIONS,
            rules: {
                staff_id: [
                    { required: true, message: '请选择员工', trigger: 'change' }
                ],
                expert_name: [
                    { required: true, message: '请输入研判专家姓名', trigger: 'blur' }
                ],
                admission_criteria: [
                    {
                        validator: (rule, value, callback) => this.validateAdmissionCriteria(rule, value, callback),
                        trigger: 'change'
                    }
                ]
            }
        }
    },
    computed: {
        selectedProjectIds() {
            const selected = new Set(this.form.admission_criteria || []);
            return this.admissionStandardSections
                .filter(group => {
                    if (selected.has(group.id)) return true;
                    const conditionIds = []
                        .concat((group.required || []).map(item => item.id))
                        .concat((group.optional || []).map(item => item.id));
                    return conditionIds.some(id => selected.has(id));
                })
                .map(group => group.id);
        },
        selectedProjectNames() {
            return this.admissionStandardSections
                .filter(group => this.selectedProjectIds.includes(group.id))
                .map(group => group.project);
        },
        currentTotalCost() {
            return this.admissionStandardSections
                .filter(group => this.selectedProjectIds.includes(group.id))
                .reduce((sum, group) => sum + (group.price || 0), 0);
        }
    },
    methods: {
        validateAdmissionCriteria(_rule, value, callback) {
            const selected = new Set(value || []);
            const selectedProjects = this.admissionStandardSections.filter(group => {
                if (selected.has(group.id)) return true;
                const conditionIds = []
                    .concat((group.required || []).map(item => item.id))
                    .concat((group.optional || []).map(item => item.id));
                return conditionIds.some(id => selected.has(id));
            });

            if (!selectedProjects.length) {
                callback(new Error('请至少勾选一项准入标准'));
                return;
            }

            const missedRequired = selectedProjects.find(group =>
                (group.required || []).some(item => !selected.has(item.id))
            );
            if (missedRequired) {
                callback(new Error(`${missedRequired.project} 的必选项未勾选`));
                return;
            }

            callback();
        },
        normalizeAdmissionCriteria(values) {
            const set = new Set(values || []);
            this.admissionStandardSections.forEach(group => {
                if (set.has(group.id)) {
                    (group.required || []).forEach(item => set.add(item.id));
                }
            });
            const normalized = Array.from(set);
            const changed = normalized.length !== (this.form.admission_criteria || []).length
                || normalized.some(item => !(this.form.admission_criteria || []).includes(item));
            if (changed) {
                this.form.admission_criteria = normalized;
            }
        },
        handleAdmissionCriteriaChange(values) {
            this.normalizeAdmissionCriteria(values);
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.validateField('admission_criteria');
                }
            });
        },
        async syncStaffInfo(staffId) {
            if (!staffId) {
                this.form.name = '';
                this.form.id_card = '';
                this.form.secondary_unit = '';
                return;
            }
            try {
                const resp = await this.$http.get(`/company/staff/${staffId}`);
                const staff = resp.data || {};
                this.form.name = staff.XM || '';
                this.form.id_card = staff.SFZH || '';
                this.form.secondary_unit = staff.EJDW || '';
            } catch (e) {
                this.$message.error(e.message || '获取员工信息失败');
            }
        },
        handleTableChange(e) {
            this.table = Object.assign({}, this.table, e);
            this.getData();
        },
        async getData() {
            this.loading = true;
            try {
                const resp = await this.$http.get('/keycare/register', {
                    params: {
                        page: this.table.page,
                        pageSize: this.table.pageSize,
                        ...this.search
                    }
                });
                this.table.data = resp.data.data;
                this.table.total = resp.data.total;
            } catch (e) {
                this.$message.error(e.message || '获取数据失败');
            }
            this.loading = false;
        },
        handleAdd() {
            this.form = {
                staff_id: null,
                name: '',
                id_card: '',
                secondary_unit: '',
                items: [],
                expert_name: '',
                admission_criteria: [],
                total_cost: 0
            };
            this.dialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.form) this.$refs.form.clearValidate();
            });
        },
        handleUpdate(row) {
            this.form = Object.assign({
                staff_id: null,
                name: '',
                id_card: '',
                secondary_unit: '',
                items: [],
                expert_name: '',
                admission_criteria: [],
                total_cost: 0
            }, JSON.parse(JSON.stringify(row)));
            this.normalizeAdmissionCriteria(this.form.admission_criteria);
            this.dialogVisible = true;
            this.syncStaffInfo(this.form.staff_id);
            this.$nextTick(() => {
                if (this.$refs.form) this.$refs.form.clearValidate();
            });
        },
        handleDelete(row) {
            this.$confirm('确认删除该申请吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const resp = await this.$http.delete(`/keycare/register/${row.id}`);
                this.$message[resp.data.status](resp.data.msg);
                if (resp.data.status == 'success') {
                    this.getData();
                }
            }).catch(() => { });
        },
        async handleSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    this.loading = true;
                    try {
                        this.form.total_cost = this.currentTotalCost;
                        this.form.items = this.selectedProjectNames;
                        await this.syncStaffInfo(this.form.staff_id);
                        // Mock submission
                        // if (this.form.id) {
                        //     await this.$http.put(`/keycare/register/${this.form.id}`, this.form);
                        // } else {
                        // }
                        const resp = await this.$http.post('/keycare/register', this.form);
                        console.log(this.form)
                        // await new Promise(resolve => setTimeout(resolve, 500)); // Simulate delay
                        this.$message[resp.data.status](resp.data.msg);
                        if (resp.data.status == 'success') {
                            this.dialogVisible = false;
                            this.getData();
                        }
                    } catch (e) {
                        this.$message.error(e.message || '提交失败');
                    }
                    this.loading = false;
                }
            });
        }
    },
    mounted() {
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
::v-deep .apply-fullscreen-dialog {
    margin-top: 0 !important;
}

::v-deep .apply-fullscreen-dialog .el-dialog__header {
    padding: 14px 20px 12px;
    border-bottom: 1px solid #ebeef5;
    background: #fff;
}

::v-deep .apply-fullscreen-dialog .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2f4d;
}

::v-deep .apply-fullscreen-dialog .el-dialog__body {
    padding: 0;
    height: calc(100vh - 56px);
    overflow: hidden;
    background: #f5f7fb;
}

.apply-page {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.apply-page-head {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 24px;
    background: #fff;
    border-bottom: 1px solid #ebeef5;
}

.apply-page-title {
    font-size: 22px;
    font-weight: 700;
    color: #1f2f4d;
}

.apply-page-subtitle {
    margin-top: 6px;
    font-size: 13px;
    color: #7b8794;
}

.apply-summary {
    display: flex;
    gap: 12px;
}

.summary-item {
    min-width: 96px;
    padding: 8px 12px;
    border: 1px solid #e5ebf3;
    border-radius: 6px;
    background: #f8fafd;
    text-align: center;
}

.summary-item span {
    display: block;
    font-size: 12px;
    color: #7b8794;
    margin-bottom: 4px;
}

.summary-item strong {
    font-size: 18px;
    color: #1f2f4d;
}

.summary-item.total strong {
    color: #f56c6c;
}

.apply-page-content {
    flex: 1;
    overflow-y: auto;
    padding: 18px 24px 88px;
}

.sheet-card {
    background: #fff;
    border: 1px solid #e9edf2;
    border-radius: 8px;
    padding: 16px 18px 6px;
    margin-bottom: 14px;
}

.sheet-card-title {
    font-size: 16px;
    font-weight: 700;
    color: #1f2f4d;
    margin-bottom: 10px;
}

.sheet-card-desc {
    margin-top: -4px;
    margin-bottom: 12px;
    color: #7b8794;
    font-size: 12px;
}

.sheet-form-item {
    margin-bottom: 8px;
}

.criteria-groups {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 8px 12px;
    background: #fff;
}

.criteria-group {
    padding: 12px 0 14px;
    border-bottom: 1px solid #ebeef5;
}

.criteria-group:last-child {
    border-bottom: none;
    padding-bottom: 8px;
}

.criteria-project {
    margin-bottom: 8px;
    padding: 6px 8px;
    background: #f8fafd;
    border-left: 3px solid #409eff;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
}

.criteria-project-checkbox {
    display: flex;
    align-items: center;
}

.criteria-project-title {
    font-size: 20px;
    font-weight: 700;
    color: #1f2f4d;
}

.criteria-project-price {
    flex-shrink: 0;
    font-size: 14px;
    color: #f56c6c;
    font-weight: 700;
}

.criteria-label {
    margin: 8px 0 6px;
    font-size: 14px;
    font-weight: 600;
    color: #606266;
}

.criteria-options {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 24px;
    padding-left: 30px;
}

.criteria-options-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(160px, 1fr));
    gap: 10px 24px;
}

@media (max-width: 1366px) {
    .criteria-options-grid {
        grid-template-columns: repeat(3, minmax(160px, 1fr));
    }
}

@media (max-width: 1024px) {
    .criteria-options-grid {
        grid-template-columns: repeat(2, minmax(160px, 1fr));
    }
}

.criteria-groups ::v-deep .el-checkbox {
    margin-right: 0;
    display: flex;
    align-items: flex-start;
    min-width: 0;
}

.criteria-groups ::v-deep .el-checkbox__label {
    font-size: 14px;
    color: #303133;
    line-height: 1.4;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
}

.criteria-project ::v-deep .el-checkbox__label {
    padding-left: 8px;
}

.criteria-options-grid ::v-deep .el-checkbox {
    width: 100%;
}

.apply-page-footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    background: #fff;
    border-top: 1px solid #ebeef5;
    box-shadow: 0 -2px 8px rgba(31, 45, 61, 0.05);
}

.footer-total {
    color: #303133;
    font-size: 14px;
}

.footer-total strong {
    color: #f56c6c;
    font-size: 22px;
    margin-left: 6px;
}

.footer-actions {
    display: flex;
    align-items: center;
    gap: 10px;
}

@media (max-width: 1280px) {
    .apply-summary {
        display: none;
    }
}
</style>
